
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weingut/werte",
      function () {
        return require("private-next-pages/weingut/werte.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weingut/werte"])
      });
    }
  